import { useTranslation } from 'react-i18next';
import { FormSection } from '@zolteam/zol-admin-ui';
import { FormElements } from '@zolteam/zol-react-form';
import AutocompleteAirports from '../../../organisms/autocompleteAirports/AutocompleteAirports';

/**
 * @typedef {object} BookingArrivalSectionProps
 * @property {import('@zolteam/zol-react-form/types').ConfigObject} formConfig
 * @property {{formName: string}} formInfo - The form information object
 * @property {{value: string, label: string} | null} arrivalAirport - Selected arrival airport
 * @property {string} arrivalAirportError - Arrival airport field error message
 * @property {(
 * airport: {value: string, label: string}, formInfo: object) => void} handleSetArrivalAirport
 * @property {(formInfo: object) => void} handleArrivalBlur - Airport field blur handler
 */

/**
 * Arrival section of the booking form
 * @param {BookingArrivalSectionProps} props
 * @returns {JSX.Element}
 */
function BookingArrivalSection({
  formConfig,
  formInfo,
  arrivalAirport,
  arrivalAirportError,
  handleSetArrivalAirport,
  handleArrivalBlur,
}) {
  const { t } = useTranslation();

  return (
    <FormSection label={t('bookingForm.section.arrival')}>
      <AutocompleteAirports
        label={t('bookingForm.fields.arrivalAirportCode')}
        value={arrivalAirport}
        setAirport={(
          /** @type {{label: string, value: string}} */newAirport,
        ) => handleSetArrivalAirport(newAirport, formInfo)}
        errorMessage={arrivalAirportError}
        name="arrivalAirport"
        onBlur={() => handleArrivalBlur(formInfo)}
      />
      <div className="margin-top-s">
        <FormElements
          translations={null}
          formConfig={formConfig}
          formTitle={formInfo.formName}
        />
      </div>
    </FormSection>
  );
}

export default BookingArrivalSection;
